import React from 'react';
import { StyleSheet, css } from 'aphrodite';

import { AppHelper } from '../helpers/AppHelper';

export const VenueSummary = ({
  item,
  site,
  deviceCodeNode,
  compact = false,
  showVenueTitle = true,
  showScreenType = true,
  showSerialNumber = true,
  showScreenPlacement = true,
  showArchived = true,
  showNotRegistered = true,
  showTesting = true,
  showExtId = true,
  showspd = false
}) => {
  const current = item || {}
  const siteInfo = site || current.site || current.siteInfo
  const title = (current && current.orgId) ? (siteInfo && siteInfo.title) || (current.info && current.info.title) : ''
  const address = (siteInfo && siteInfo.address) || (current.info && current.info.address)
  const serialNumber = current.latestDeviceFeed && current.latestDeviceFeed.serialnumber
    ? current.latestDeviceFeed.serialnumber
    : current.serialNumber
  const showSerial = showSerialNumber &&
    serialNumber &&
    typeof serialNumber === 'string' &&
    serialNumber.toLowerCase() !== 'unknown'
  const normalizedVenueTitle = current.title && current.title.trim().toLowerCase()
  const normalizedSiteTitle = title && title.trim().toLowerCase()
  const shouldShowVenueTitle = showVenueTitle && current.title && normalizedVenueTitle !== normalizedSiteTitle
  const screenDimension = (current.info && current.info.screenDimension)
  const screenBrand = (current.info && current.info.screenBrand)
  const brandName = (current.brandName)
  const screenModel = (current.info && current.info.screenModel)
  const category = (current.info && current.info.category)
  const pricingTier = (current.info && current.info.pricingTier)
  const screenPlacementDetails = current.info && current.info.screenPlacementDetails
  const shouldShowScreenPlacementDetails = showspd === true &&
    typeof screenPlacementDetails === 'string' && screenPlacementDetails.trim().length > 0

  return (
    <div className={css(Styles.container, compact && Styles.compactContainer)}>
      {/* <pre>
        {JSON.stringify(current,null,2)}
      </pre> */}
      {title &&
        <div>
          <span className={css(Styles.storeNameText, compact && Styles.compactStoreNameText, Styles.truncateLine)}>{title}</span>
        </div>
      }
      {address &&
        <div>
          <span className={css(Styles.line2, compact && Styles.compactLine2, Styles.truncateLine)}>{address}</span>
        </div>
      }
      {compact && showScreenType && current.info && current.info.openoohcategory &&
        <div>
          <span className={css(Styles.line2, Styles.truncateLine, compact && Styles.compactLine2)}>Screen Type: {current.info.openoohcategory}</span>
        </div>
      }
      {compact && showScreenPlacement && current.info && current.info.screenPlacement &&
        <div>
          <span className={css(Styles.line2, Styles.truncateLine, compact && Styles.compactLine2)}>Screen Placement: {current.info.screenPlacement}</span>
        </div>
      }
      {compact && screenModel &&
        <div>
          <span className={css(Styles.line2, Styles.truncateLine, compact && Styles.compactLine2)}>Screen Model: {current.info.screenModel}</span>
        </div>
      }
      {compact && screenBrand &&
        <div>
          <span className={css(Styles.line2, Styles.truncateLine, compact && Styles.compactLine2)}>Screen Brand: {current.info.screenBrand}</span>
        </div>
      }
      {compact && brandName &&
        <div>
          <span className={css(Styles.line2, Styles.truncateLine, compact && Styles.compactLine2)}>Brand Name: {brandName}</span>
        </div>
      }
      {compact && category &&
        <div>
          <span className={css(Styles.line2, Styles.truncateLine, compact && Styles.compactLine2)}>Category: {current.info.category}</span>
        </div>
      }
      {compact && pricingTier &&
        <div>
          <span className={css(Styles.line2, Styles.truncateLine, compact && Styles.compactLine2)}>Pricing Tier: {pricingTier}</span>
        </div>
      }
      {compact && screenDimension &&
        <div>
          <span className={css(Styles.line2, Styles.truncateLine, compact && Styles.compactLine2)}>Screen Dimension: {current.info.screenDimension}</span>
        </div>
      }
      {compact && showSerial &&
        <div>
          <span className={css(Styles.line2, Styles.truncateLine, compact && Styles.compactLine2)}>SN: {serialNumber}</span>
        </div>
      }

      {/* Non Compact UI */}
      {!compact && showScreenType && current.info && current.info.openoohcategory &&
        <div>
          <span className={css(Styles.line2)}>Screen Type: {current.info.openoohcategory}</span>
        </div>
      }
      {!compact && showScreenPlacement && current.info && current.info.screenPlacement &&
        <div>
          <span className={css(Styles.line2)}>Screen Placement: {current.info.screenPlacement}</span>
        </div>
      }
      {!compact && screenModel &&
        <div>
          <span className={css(Styles.line2)}>Screen Model: {screenModel}</span>
        </div>
      }
      {!compact && screenBrand &&
        <div>
          <span className={css(Styles.line2)}>Screen Brand: {screenBrand}</span>
        </div>
      }
      {!compact && brandName &&
        <div>
          <span className={css(Styles.line2)}>Brand Name: {brandName}</span>
        </div>
      }
      {!compact && category &&
        <div>
          <span className={css(Styles.line2)}>Category: {category}</span>
        </div>
      }
      {!compact && pricingTier &&
        <div>
          <span className={css(Styles.line2)}>Pricing Tier: {pricingTier}</span>
        </div>
      }
      {!compact && screenDimension && current.info && current.info.screenDimension &&
        <div>
          <span className={css(Styles.line2)}>Screen Dimension: {current.info.screenDimension}</span>
        </div>
      }
      {!compact && showSerial &&
        <div>
          <span className={css(Styles.line2)}>SN: {serialNumber}</span>
        </div>
      }
      {/* ------ */}
      {(deviceCodeNode || current.deviceCode) &&
        <div>
          <span className={css(Styles.line2, compact && Styles.compactLine2, Styles.truncateLine)}>{deviceCodeNode || current.deviceCode}</span>
        </div>
      }
      {shouldShowVenueTitle &&
        <div>
          <span className={css(Styles.line2, compact && Styles.compactLine2, Styles.truncateLine)}>{current.title}</span>
        </div>
      }
      {showArchived && current.state === 'ARCHIVED' &&
        <div>
          <span className={css(Styles.line2, compact && Styles.compactLine2, Styles.truncateLine)}>ARCHIVED</span>
        </div>
      }
      {showNotRegistered && !current.installationId && !AppHelper.isNonApkDevice(current) &&
        <div>
          <span className={css(Styles.line2, compact && Styles.compactLine2, Styles.truncateLine)}>NOT REGISTERED</span>
        </div>
      }
      {showTesting && current.testing === 'YES' &&
        <div>
          <span className={css(Styles.line2, compact && Styles.compactLine2, Styles.truncateLine)}>TESTING(NOT SSP)</span>
        </div>
      }
      {showExtId && current.extId &&
        <div>
          <span className={css(Styles.line2, compact && Styles.compactLine2, Styles.truncateLine)}>EXTID: {current.extId}</span>
        </div>
      }
      {shouldShowScreenPlacementDetails &&
        <div className={css(Styles.screenPlacementDetails)}>
          <span className={css(Styles.line2, compact && Styles.compactLine2, Styles.truncateLine)}>{screenPlacementDetails}</span>
        </div>
      }
    </div>
  )
}

const Styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2
  },
  compactContainer: {
    gap: 1
  },
  screenPlacementDetails: {
    borderTop: '1px solid #ddd',
    marginTop: 4,
    paddingTop: 4
  },
  storeNameText: {
    fontWeight: 'bolder',
    fontSize: '16px',
    color: '#121212'
  },
  compactStoreNameText: {
    fontSize: '14px',
    lineHeight: '18px'
  },
  line2: {
    fontSize: 12
  },
  compactLine2: {
    fontSize: 11,
    lineHeight: '16px'
  },
  truncateLine: {
    display: 'block',
    maxWidth: '100%',
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    overflowWrap: 'anywhere'
  }
})



// WEBPACK FOOTER //
// ./src/components/VenueSummary.js